import { ApiError } from "./ApiError";
import { captureApiError } from "./captureApiError";
import { addBreadcrumb, captureException } from "./sentry";

const FETCH_NETWORK_ERROR_MESSAGES = [
  "failed to fetch",
  "load failed",
  "networkerror when attempting to fetch resource",
  "the internet connection appears to be offline",
];

type CaptureReactQueryErrorArgs = {
  error: unknown;
  context: Record<string, unknown>;
  hasQueryData?: boolean;
};

export const isFetchNetworkError = (error: unknown): boolean => {
  if (!(error instanceof TypeError)) {
    return false;
  }

  const message = error.message.toLowerCase();

  return FETCH_NETWORK_ERROR_MESSAGES.some((networkErrorMessage) =>
    message.includes(networkErrorMessage),
  );
};

export const captureReactQueryError = ({
  error,
  context,
  hasQueryData = false,
}: CaptureReactQueryErrorArgs): void => {
  if (hasQueryData && isFetchNetworkError(error)) {
    addBreadcrumb({
      category: "react-query",
      message: "Background refetch network error with cached data",
      level: "warning",
      data: context,
    });
    return;
  }

  if (error instanceof ApiError) {
    captureApiError(error, context);
    return;
  }

  captureException(
    error instanceof Error ? error : new Error(String(error)),
    context,
  );
};
